
// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyB2ePpIjNeukskiYO97ZD577qOzgwQOTrE",
    authDomain: "medicare-assign-10-pro.firebaseapp.com",
    projectId: "medicare-assign-10-pro",
    storageBucket: "medicare-assign-10-pro.appspot.com",
    messagingSenderId: "80915405808",
    appId: "1:80915405808:web:7c680b9f293c34bed4db35"
  };
export default firebaseConfig;  